module.exports = __webpack_public_path__ + "img/logo.012c0ecb.png";